var _defs, _g, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16828",
    "data-name": "Group 16828",
    width: 28,
    height: 34,
    viewBox: "0 0 28.005 34.495"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2496",
    "data-name": "Rectangle 2496",
    width: 28.005,
    height: 34.495,
    fill: "#035e88"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16647",
    "data-name": "Group 16647",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16476",
    "data-name": "Group 16476",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7099",
    "data-name": "Path 7099",
    d: "M27.909,10.121,17.75.012,3.161,0A3.717,3.717,0,0,0,0,3.192L0,31.2a3.7,3.7,0,0,0,3.459,3.3H24.545A3.732,3.732,0,0,0,28,31.275l0-20.761Zm-2.431-.3h-5.25a2.457,2.457,0,0,1-1.974-1.688L18.235,2.5Zm1.14,21.124a2.443,2.443,0,0,1-1.528,1.972c-7.361.174-14.813.174-22.174,0A2.358,2.358,0,0,1,1.383,30.79V3.677c-.079-.784.981-2.235,1.753-2.235H16.769V8.076c0,1.26,1.784,3.134,3.053,3.134H26.5l.122.122Z",
    transform: "translate(0 0)",
    fill: "#035e88"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x2: 17.099,
    transform: "translate(5.453 15.588)",
    fill: "none",
    stroke: "#035e88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x2: 17.099,
    transform: "translate(5.453 21.622)",
    fill: "none",
    stroke: "#035e88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x2: 17.099,
    transform: "translate(5.453 27.657)",
    fill: "none",
    stroke: "#035e88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
};
export default "data:image/svg+xml;base64,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";
export { SvgDoc as ReactComponent };